module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_63"
    }
  }, [_c('span', [_vm._v("53")])]), _vm._v(" "), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e696963"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c4_r1#d6e10",
      "id": "d7e10"
    }
  }, [_c('i', [_vm._v("Introduction ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "epigraph",
    attrs: {
      "id": "d7e697463"
    }
  }, [_c('span', [_c('i', [_vm._v("Surprised by joy, impatient, as the wind I turned to share the transport.")])])]), _vm._v(" "), _c('p', {
    staticClass: "extbd",
    attrs: {
      "id": "d7e698563"
    }
  }, [_c('span', [_vm._v("—W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILLIAM ")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORDSWORTH ")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e699063"
    }
  }, [_c('span', [_vm._v("Of Lewis’s four causes of laughter, the highest and most sublime is joy. Yet its arrival, as Frederick Buechner observes, is as “notoriously unpredictable as the one who bequeaths it.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d141",
      "id": "a141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" God in His wisdom withholds it from His children at some moments, and in His mercy pours it out on them at others. Fun, the joke proper, and flippancy can be planned and produced by any person. But joy can be received only from the One whose presence is absolute joy.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e702163"
    }
  }, [_c('span', [_vm._v("For C. S. Lewis, the purest laughter on earth dwells in the kingdom of joy. When joy reigns in the land, the sound of laughter is never far away. Silvery volleys of laughter fall on every dale and in every valley of the countryside where the King of joy rules. In Lewis’s underworld kingdom of pride and selfishness, the devil Screwtape reserved some of his sharpest criticism for this seemingly hallowed laughter of joy. He found it utterly repulsive and repugnant to the ego-infested environs of hell. He attacked its exhilaration and merriment as inappropriate for creatures whose cardinal value is self-importance. This offensive jocundity, Screwtape wrote in a letter classifying the types of laughter, was what one would see")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e705763"
    }
  }, [_c('span', [_vm._v("among friends and lovers reunited on the eve of a holiday. Among adults some pretext in the way of jokes is usually provided, but the facility with which the smallest witticisms produce laughter at such a time shows that they are not the real cause. What the real cause is we do not know. . . . Laughter of this kind does us no good and should always be discouraged. Besides, this phenomenon is of itself disgusting and a direct insult to the realism, dignity, and austerity of hell."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d142",
      "id": "a142",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_64"
    }
  }, [_c('span', [_vm._v("54")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e708964"
    }
  }, [_c('span', [_vm._v("For Screwtape, the affront of this laughter carried a mystery that runs counter to the fallen nature of human beings. For Lewis, joy is at the heart of Christianity—it is the gigantic secret that compels women and men into the company of the Cross and characterizes the fruit of their sufferings. It converts a wide, diverse throng of sad, lonely pilgrims into a fellowship of blessedness, bringing all into a dance of comedy. Indeed, if there is any laughter that expresses the character of God, it may be presumed to be that of joy. In His season of much anguish with trouble brewing, Jesus promised His disciples that His joy might be in them and that their joy might be full (John 15:11). The promise intimated that laughter would yet rush into the vale of tears and bring this motley gang of proud and competing disciples together into a fellowship of joy.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e713464"
    }
  }, [_c('span', [_vm._v("The heavens teem with life, singing the glories and joys of God. Thunder resounds the cosmos’s hearty laughter (and not, as Aristophanes called it, divine flatulence) from the throne room of God, and lightning could be the flash of wit. Laughter reigns in the heavenlies in unmasked and unmeasured abundance; there is celestial joy forevermore. When Ransom, Lewis’s protagonist in "), _c('i', [_vm._v("Out of the Silent Planet")]), _vm._v(", is on the way to Malacandra (Mars), he is overwhelmed by a joyous “exaltation of heart,” which spins out of his realization that space is not dead and empty, but rather that the heavens are as alive and nourishing as a womb.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e717564"
    }
  }, [_c('span', [_vm._v("Beneath the heavens, on the humble earth, joy descends. When angels appear with the incredible good news for the geriatric couple in Genesis, Sarah falls down and breaks out laughing. The gospel of Luke bursts with joy, as messengers of God interrupt daily life. When an angel spears in that narrative, people usually break forth in song and joy. The "), _c('i', [_vm._v("Magnificat ")]), _vm._v("of Mary celebrates all that is good and blessed: “My soul exalts the Lord, and my spirit has rejoiced in God my Savior” (Luke 1:46–47). The Queen of Perelandra echoes the blessed Mary and sings her own version of the "), _c('i', [_vm._v("Magnificat")]), _vm._v(", in which praise, delight, and blessing swirl about in a great dance of glory.")])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_65"
    }
  }, [_c('span', [_vm._v("55")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e722665"
    }
  }, [_c('span', [_vm._v("Joy dominated Lewis’s life and characterized his deepest longings. Life to him was a wandering toward the source of this joy—toward one’s real home. The journey may be rough and tiring and even tedious, but it offers surprises to a traveler at those very hours when he or she ought to be miserable. Lewis rightly noted that “one is more often happy than wretched without apparent cause.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d143",
      "id": "a143",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" Each surprise is a free sample of joy, foretastes of heavenly pleasure, offered without explanation. On a train trip from London, Lewis discovered he was invited to experience a moment of Eden:")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e726365"
    }
  }, [_c('span', [_vm._v("I am free to take it or not as I choose—like distant music which you need not listen to unless you wish, like a delicious faint wind on your face which you can easily ignore. One was invited to surrender to it. And the odd thing is that something inside me suggested that it would be “sensible” to refuse the invitation; almost that I would be better employed in remembering that I was going to do a job I do not greatly enjoy and that I should have a very tiresome journey back to Oxford. Then I silenced this inward wiseacre. I accepted the invitation—threw myself open to this feathery, impalpable, tingling sensation. The rest of the journey I passed in a state which can be described only as joy."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d144",
      "id": "a144",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e730465"
    }
  }, [_c('span', [_vm._v("A greedy impatience to snare, grasp, and keep joy, however, is the surest way to lose it. It can be instantly frightened away by introspection. It also can be vulgarized. “Those who think that if adolescents were all provided with a suitable mistress we should soon hear no more of ‘immortal longings’ are certainly wrong.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d145",
      "id": "a145",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" Lewis’s character John in "), _c('i', [_vm._v("The Pilgrim’s Regress")]), _vm._v(", made this mistake repeatedly, seeking joy through fornication with the brown girl. Pleasure can be found in sexual experience, but John discovered that pleasure was not what he was seeking. Lewis said the offer of sexual pleasure as an alternative to the desire of joy compared to offering a mutton chop to a man dying of thirst: “Joy is not a substitute for sex; sex is very often a substitute for Joy. I sometimes wonder whether all pleasures are not substitutes for Joy.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d146",
      "id": "a146",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" Lewis distinguished what he technically defined as joy both")])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_66"
    }
  }, [_c('span', [_vm._v("56")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e736466"
    }
  }, [_c('span', [_vm._v("from Happiness and Pleasure. Joy (in my sense) has indeed one characteristic, and one only, in common with them; that fact that anyone who has experienced it will want it again. Apart from that, and considered only in its quality, it might almost equally well be called a particular kind of unhappiness or grief. But it is a kind we want. I doubt whether anyone who has tasted it would ever, if both were in his power, exchange it for all the pleasures in the world. But then Joy is never in our power and pleasure often is."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d147",
      "id": "a147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e739566"
    }
  }, [_c('span', [_vm._v("When joy did appear in Lewis’s life, it stripped away the veneer of all his erotic and magical perversions of it. The latter were distinctly separate experiences, he recognized, and in contrast looked like “sordid trumpery.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d148",
      "id": "a148",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" True joy had a vastly different effect: It did not disenchant the ordinary. The “bread upon the table or the coals in the grate” became sharper and more splendidly themselves.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e742566"
    }
  }, [_c('span', [_vm._v("What distinguished joy from happiness or pleasure was, for Lewis, a defining characteristic of longing—a deep yearning or poignant desire for something agonizingly elusive. Just as one’s pleasure in spring contains a memory of winter longings, joy for Lewis always contained “the stab, the pang, the inconsolable longing.” This underlying quality of joy in Lewis’s system, then, was “that of an unsatisfied desire which is itself more desirable than any other satisfaction.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d149",
      "id": "a149",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e745366"
    }
  }, [_c('span', [_vm._v("The German language has a word for this joy-ward longing that Lewis describes: "), _c('i', [_vm._v("Sehnsucht")]), _vm._v(". This is the haunting longing that touched Lewis throughout his life, that full, heavy, enveloping nostalgia for a fulfillment that awaited him—in something, somewhere.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c4b6583","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Lind_9781595554796_epub_c14_r1.vue
// module id = 96
// module chunks = 0